// extracted by mini-css-extract-plugin
export default {"fieldset":"BaseFieldset-T7ZXx__fieldset"};